export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    cardWidgetLoaded: function () {
      const description = $(`#${widgetName} .card-widget-description`);
      const buttonWrap = $(`#${widgetName} .buttonwrap`);
      const outerdiv = $('<div>', { class: 'description-and-button-wrap' });
      outerdiv.append(description, buttonWrap);
      $(`#${widgetName}`).append(outerdiv);
      $(`#${widgetName} .buttonwrap a`).addClass('button');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    moreButton: {
      visible: true,
      text: 'learn more',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
